import { Outlet } from "react-router-dom";
import { withFadeTransition } from "../../../StoreComponents/StoreTransition";

const ShopOutlet = () => {
  return <Outlet />;
};

export default withFadeTransition(ShopOutlet);
